/* eslint-disable */
/*
/* This file is generated automatically by i18n preprocessor. Do not modify it directly.
 */
import { addLang, locale } from '../src/locale';

const defaultLocale = 'en-US';
const i18n = {
  "en-US": {
    "upload": {
      "deleteTip": "Press delete to remove",
      "delete": "Delete",
      "preview": "Preview",
      "continue": "Continue"
    }
  },
  "de-DE": {
    "upload": {
      "deleteTip": "Zum Entfernen Delete drücken",
      "delete": "Löschen",
      "preview": "Vorschau",
      "continue": "Weiter"
    }
  },
  "es-ES": {
    "upload": {
      "deleteTip": "Pulse la tecla Supr para eliminar",
      "delete": "Eliminar",
      "preview": "Vista previa",
      "continue": "Continuar"
    }
  },
  "fr-FR": {
    "upload": {
      "deleteTip": "Appuyez sur Supprimer pour le supprimer",
      "delete": "Supprimer",
      "preview": "Aperçu",
      "continue": "Continuer"
    }
  },
  "it-IT": {
    "upload": {
      "deleteTip": "Premi Cancella per rimuovere",
      "delete": "Elimina",
      "preview": "Anteprima",
      "continue": "Continua"
    }
  },
  "jp-JP": {
    "upload": {
      "deleteTip": "Deleteを押して削除してください",
      "delete": "削除",
      "preview": "プレビュー",
      "continue": "続行"
    }
  },
  "ko-KO": {
    "upload": {
      "deleteTip": "Delete 키를 눌러 제거",
      "delete": "삭제",
      "preview": "미리 보기",
      "continue": "계속"
    }
  },
  "pt-PT": {
    "upload": {
      "deleteTip": "Pressione Delete para remover",
      "delete": "Excluir",
      "preview": "Visualização",
      "continue": "Continuar"
    }
  },
  "ru-RU": {
    "upload": {
      "deleteTip": "Нажмите кнопку delete, чтобы удалить",
      "delete": "Удалить",
      "preview": "Предпросмотр",
      "continue": "Продолжить"
    }
  },
  "vi-VN": {
    "upload": {
      "deleteTip": "Nhấn delete để xóa bỏ",
      "delete": "Xóa",
      "preview": "Xem trước",
      "continue": "Tiếp tục"
    }
  },
  "zh-CN": {
    "upload": {
      "deleteTip": "按Delete键移除",
      "delete": "删除",
      "preview": "预览",
      "continue": "继续"
    }
  },
  "zh-TW": {
    "upload": {
      "deleteTip": "按下Delete可移除",
      "delete": "刪除",
      "preview": "預覽",
      "continue": "繼續"
    }
  }
};
const lang = i18n[locale] ? i18n[locale] : i18n[defaultLocale];

addLang(lang);
